export const properties = {
    // host: "http://localhost:8080"
    // host: "http://rexiusalgorithmsservice-env.eba-utxzpgtu.us-west-2.elasticbeanstalk.com"
    host: "https://api.rexiusalgorithms.com"
};